export const getResponsiveMaxWidth = () => {
    return `@media (min-width: 1080px) {
      max-width: 650px;
    }`;
};
